exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoices-table tr td:hover {\n  cursor: pointer;\n}\n.invoices-table .VueTables__table {\n  min-height: 300px;\n}\n", ""]);

// exports
